module.exports = __webpack_public_path__ + "img/WANING_CRESCENT.7b1fc540.png";